import triggerModal from "./components/modal";
import { initPostsSlider, initFeedbackSlider } from "./components/sliders";
import initScrollDetector from "./components/scroll-detector";
import addAccordion from "./components/accordion";
import initTabs from "./components/tabs";
import imageLightbox from "./components/image-lightbox";
import triggerLangOverlay from "./components/lang-switcher";

triggerModal();
initPostsSlider();
initFeedbackSlider();
initScrollDetector();
addAccordion();
initTabs();
imageLightbox();
triggerLangOverlay();

function openMenu() {
  function init() {
    const btn = document.querySelector(".mobile-menu-btn");
    const menu = document.querySelector(".mobile-menu-wrap");

    btn.addEventListener("click", () => {
      btn.classList.toggle("active");
      menu.classList.toggle("is-open");
      document.body.classList.toggle("mobile-menu-open");
    });
  }

  const isPresent = document.getElementsByClassName("mobile-menu-btn");
  if (isPresent.length > 0) {
    init();
  }
}

openMenu();

function toggleMobileSubMenus() {
  const triggers = document.querySelectorAll(
    ".primary-nav-mobile li.menu-item-has-children > a"
  );

  triggers.forEach((trigger) => {
    trigger.addEventListener("click", (e) => {
      e.preventDefault();
      trigger.nextElementSibling.classList.toggle("open");
    });
  });
}

toggleMobileSubMenus();
